<template>
	<div class="container_page">
		<div class="filter_box">
			<div class="flex">
				<a-input v-model="filterData.version" style="width: 150px" class="mr12"
					placeholder="请输入版本号"></a-input>
				<a-select v-model="filterData.appType" style="width: 150px" class="mr12 mb10" placeholder="APP" @change="getData(1)" show-search option-filter-prop="name" :filter-option="filterOption">
						<a-select-option v-for="(item, index) of appTypeList" :key="index" :value="item.value">
							{{ item.label }}
						</a-select-option>
					</a-select>
					<a-select v-model="filterData.updateStatus" style="width: 150px" class="mr12 mb10" placeholder="强制更新" @change="getData(1)" show-search option-filter-prop="name" :filter-option="filterOption">
						<a-select-option v-for="(item, index) of updateStatusList" :key="index" :value="item.value">
							{{ item.label }}
						</a-select-option>
					</a-select>
				<a-button class="mr12" type="primary" @click="toSearch(true)">搜索</a-button>
				<a-button class="mr12" @click="toSearch(false)">清空</a-button>
				<a-button class="mr12" type="primary" @click="toAdd">新增</a-button>
			</div>
			<span></span>
		</div>
		<a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
			:loading="loading" :rowKey="record => record.versionId">
			<template slot="updateStatus" slot-scope="text, record">
				<div v-if="record.updateStatus !== null">
					{{ record.updateStatus==true?'是': record.updateStatus==false?'否':''}}
				</div>
			</template>
			<template slot="action" slot-scope="text, record">
				<div class="flex_center">
					<a-button type="link" @click="toEdit(record)">编辑</a-button>
					<a-button type="link" @click="toDelete(record)">删除</a-button>
				</div>
			</template>
		</a-table>
		<a-modal :visible="imgModel.flag" width="880px" :closable="false" maskClosable :destroyOnClose="true">
			<template slot="footer">
				<a-button @click="imgModel.flag = false">关闭</a-button>
			</template>
			<span>
				<img :src="imgModel.url" alt="" style="width: 800px;height: 296px" />
			</span>
		</a-modal>
		<a-modal :title="tipsModel.title" :visible="tipsModel.flag" @ok="tipsModel.onOk"
			@cancel="tipsModel.flag = false">
			<span>
				{{ tipsModel.content }}
			</span>
		</a-modal>
		<a-modal :title="editModel.title" :visible="editModel.flag" width="700px" @ok="editModel.onOk"
			@cancel="editModel.flag = false">
			<a-form-model :model="editModel" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row>
					<a-col :span="20">
						<a-form-model-item label="APP">
							<a-select v-model="editModel.appType"  class="mr12 mb10" placeholder="APP" show-search option-filter-prop="name" :filter-option="filterOption">
								<a-select-option v-for="(item, index) of appTypeList" :key="index" :value="item.value">
									{{ item.label }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>

				<a-row>
					<a-col :span="20">
						<a-form-model-item label="版本号">
							<a-input v-model="editModel.version" />
						</a-form-model-item>
					</a-col>
				</a-row>

				<a-row>
					<a-col :span="20">
						<a-form-model-item label="更新描述">
							<a-input v-model="editModel.updateDesc" />
						</a-form-model-item>
					</a-col>
				</a-row>

				<a-row>
					<a-col :span="20">
						<a-form-model-item label="更新地址">
							<a-input v-model="editModel.appUrl" />
						</a-form-model-item>
					</a-col>
				</a-row>

				<a-row>
					<a-col :span="20">
						<a-form-model-item label="强制更新">
							<a-select v-model="editModel.updateStatus"  class="mr12 mb10" placeholder="强制更新"  show-search option-filter-prop="name" :filter-option="filterOption">
						<a-select-option v-for="(item, index) of updateStatusList" :key="index" :value="item.value">
							{{ item.label }}
						</a-select-option>
					</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>


		</a-modal>
	</div>
</template>

<script>
	import {
		getVersionApi,
		setVersionApi,
		deleteVersionApi,
		getOssAuth,
	} from "../../api/index";
	export default {
		name: "settingVersionList",
		data() {
			return {
				// APP ANDROID 安卓 、IOS 苹果
				appTypeList:[{
						label: "安卓",
						value: "ANDROID",
					},
					{
						label: "苹果",
						value: "IOS",
					}
				],
				// 强制更新 true 是 false 否
				updateStatusList:[{
						label: "是",
						value: true,
					},
					{
						label: "否",
						value: false,
					}],
				columns: [{
						title: "versionId",
						key: "versionId",
						dataIndex: "versionId",
					},
					{
						title: "APP",
						dataIndex: "appType",
						key: "appType",
					},
					{
						title: "版本号",
						dataIndex: "version",
						key: "version",
					},
					{
						title: "更新描述",
						dataIndex: "updateDesc",
						key: "updateDesc",
					},
					{
						title: "更新地址",
						dataIndex: "appUrl",
						key: "appUrl",
					},
					{
						title: "强制更新",
						dataIndex: "updateStatus",
						key: "updateStatus",
						scopedSlots: {
							customRender: "updateStatus"
						}
					},
					{
						title: "创建时间",
						dataIndex: "createTime",
						key: "createTime",
					},
					{
						title: "操作",
						key: "action",
						scopedSlots: {
							customRender: "action"
						},
					},
				],
				filterData: {
					version: "",
					appType:undefined,
					updateStatus:undefined,
				},
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				imgModel: {
					flag: false,
					url: "",
				},
				tipsModel: {
					flag: false,
					title: "",
					content: "",
					versionId: '',
					onOk: () => {},
				},
				editModel: {
					title:"",
					flag: false,
					appType: "",
					version: "",
					updateDesc: '',
					versionId:"",
					appUrl: "",
					updateStatus: "",
					onOk: () => {},
				},
				formState: {
					"bankIcon": "", //卡片图标
					"name": "", //卡片名称
					"sort": 1 //序号
				},
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 18
				},
			};
		},
		created() {},
		activated() {},
		mounted() {
			const storedQuery = localStorage.getItem('settingBankList_searchQuery');
			if(storedQuery){
				this.filterData = JSON.parse(storedQuery);
				this.getData(1);
			} else {
				this.getData(1);
			}
		},
		beforeRouteLeave(to, from, next) {
			localStorage.setItem('settingBankList_searchQuery', JSON.stringify(this.filterData));
			next();
		},
		methods: {
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			toSearch(flag) {
				if (flag) {
					this.getData(1);
				} else {
					this.filterData = {
						version: "",
						appType:undefined,
						updateStatus:undefined,
					};
					this.getData(1);
				}
			},
			changePage(page) {
				this.pageInfo.current = page.current;
				this.getData(this.pageInfo.current);
			},
			getData(page = 1) {
				this.pageInfo.current = page;
				if (this.loading) {
					return;
				}
				this.loading = true;
				getVersionApi({
						pageNo: this.pageInfo.current,
						pageSize: this.pageInfo.pageSize,
						version:this.filterData.version,
						appType:this.filterData.appType,
						updateStatus:this.filterData.updateStatus,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.tableData = res.resultData.dataList || [];
							this.pageInfo.total = res.resultData.totalNum || 0;

						} else {
							this.tableData = [];
							this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			toAdd() {
				this.editModel = {
					flag: true,
					title: "新增",
					appType: "",
					version: '',
					updateDesc: '',
					versionId:0,
					appUrl: "",
					updateStatus: "",
					sort: this.pageInfo.total + 1,
					onOk: this.sureEdit,
				};
			},
			toEdit(data) {
				this.editModel = {
					flag: true,
					title: "编辑",
					versionId:data.versionId,
					appType: data.appType,
					version: data.version,
					updateDesc: data.updateDesc,
					appUrl: data.appUrl,
					updateStatus: data.updateStatus,
					sort: data.sort,
					onOk: this.sureEdit,
				};
			},
			confirm() {

			},
			sureEdit() {
				setVersionApi({
						appType: this.editModel.appType,
						version: this.editModel.version,
						updateDesc: this.editModel.updateDesc,
						appUrl: this.editModel.appUrl,
						updateStatus: this.editModel.updateStatus,
						versionId:this.editModel.versionId
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								this.editModel.versionId ? "编辑成功" : "新增成功"
							);
							this.editModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.getData()
					})
			},
			toDelete(data) {
				this.tipsModel = {
					flag: true,
					title: "删除",
					content: "确认要删除吗？",
					versionId: data.versionId,
					onOk: this.sureDelete,
				};
			},
			toSeeImg(data) {
				this.imgModel = {
					flag: true,
					url: data.bankIcon,
				};
			},
			sureDelete() {
				if (this.loading) {
					return;
				}
				this.loading = true;
				deleteVersionApi({
						versionId: this.tipsModel.versionId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("删除成功");
							this.tipsModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						this.$message.error(
							res.errorMessage
						);
						console.log(error);
					})
					.finally(() => {
						this.loading = false;
						this.getData(1);
					});
			},
			// 上传文件
			handleUpdataFile(e) {
				if (e.target.files.length) {
					const file = e.target.files[0];
					console.log("file", file);
					if (file) {
						const form = new FormData();
						form.append("file", file);
						console.log("form", form);
						getOssAuth(form).then((res) => {
							if (res.resultStatus) {
								this.editModel.bankIcon = res.resultData.fileLink;
							}
						});
					}
				}
			},
		},
	};
</script>

<style lang="less">
	.container_page {
		padding: 20px;
		background: #ffffff;
		.filter_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
		}

		.mr12 {
			margin-right: 12px;
		}
	}
</style>
